$(document).ready(function() {

    // zobrazeni vice popisu v detailu nemovitosti
    (function() {
        var $el, $p, $ps, $up, totalHeight, layoutHeight;

        if ($(".JS-estateDesc").height() > window.setting.NEMOVITST_DESCRIPTION_HEIGHT)
        {
            layoutHeight = window.setting.NEMOVITST_DESCRIPTION_HEIGHT;

            //nastaveni výšky elementu, aby skryl přebytečný text
            $(".JS-estateDesc").css('height',layoutHeight);
            $('.JS-estateDesc .read-more').show();
            $('.read-more.show-more .EstateShowMoreDesc').click(function(e) {
                e.preventDefault();
                $('a.EstateShowMoreDesc').removeClass('active');
                $(this).addClass('noactive');
                $('a.EstateShowMoreDesc').removeClass('noactive');
                $(this).addClass('active');


                //inspirace http://css-tricks.com/text-fade-read-more/
                totalHeight = 0

                $el = $(this);
                $p  = $el.parent();
                $up = $p.parent();
                $ps = $up.find("p");


                // measure how tall inside should be by adding together heights of all inside paragraphs (except read-more paragraph)
                $ps.each(function() {
                    totalHeight += $(this).outerHeight() + 50;
                });

                if(!$up.hasClass("long")){

                    $up
                        .css({
                            // Set height to prevent instant jumpdown when max height is removed
                            "height": $up.height(),
                            "max-height": 9999
                        })
                        .animate({
                            "height": totalHeight
                        })
                        .toggleClass("long");

                } else {
                    $up
                        .animate({
                            "height": layoutHeight
                        })
                        .toggleClass("long");
                }

            });
        }
    }());
});